<template>
  <div class="NonActiveRAComponent">
    <div class="component-inner-section">
      <div class="main-section">
        <div v-if="userProfile && !userProfile.mark_as_verified_user">
          <img
            src="../assets/images/RA-dashboard/Non-verified dashboard Image.svg"
            class="non-active-banner-img non-ra-banner"
            alt=""
          />

          <h3 class="top-margin-20">Only SEBI Experts Have Access To <br> StockAnts CRM</h3>
        </div>
        <div v-else-if="user_details && !user_details.is_active_ra">
          <img
            src="../assets/images/RA-dashboard/Frame 158.svg"
            class="non-active-banner-img"
            alt=""
          />

          <div class="details-box">
            <div class="head">
              <img
                src="../assets/images/RA-dashboard/Lock Icon.svg"
                class="lock-img"
                alt=""
              />
              Access to StockAnts
              <span style="color: #2d2e8d; margin-left: 4px;"> CRM</span>
            </div>

            <div class="list">
              <p>
                <i class="el-icon-check"></i> Unlock Seamless Real-time User
                Engagement
              </p>
              <p><i class="el-icon-check"></i> Export user data in excel</p>
              <p>
                <i class="el-icon-check"></i> Direct Messaging & Communication
                with users
              </p>
            </div>
          </div>

          <div class="top-margin-20 btn-theme-filled publish-btn" @click="goToLink('/upload-recommendation')">
            PUBLISH NOW
            <img
              src="../assets/images/Publish Icon (1).svg"
              alt=""
            />
          </div>

          <p class="bottom-txt">(Minimum 2 Recommendations in last 30 days)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NonActiveRAComponent",
  props: [],
  components: {},
  data() {
    return {
      // currentUrl: localStorage.getItem("currentUrl")
      //     ? localStorage.getItem("currentUrl")
      //     : window.location.href,

      userProfile: localStorage.getItem("profile")
        ? JSON.parse(localStorage.getItem("profile"))
        : null,
    };
  },

  computed: {
    // return user details e.g. accuracy, success rate, rating etc.
     // return user details e.g. accuracy, success rate, rating etc.
     user_details() {
      return this.$store.state.user_details;
    }
  },
  
  methods:{
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.NonActiveRAComponent {
  .component-inner-section {
    position: absolute;
    top: 109px;
    width: calc(100% - 290px);
    min-height: calc(100vh - 90px);
    background-color: #fffffffa;
    display: flex;
    // align-items: center;
    justify-content: center;
    overflow: hidden;
    left: 280px;
    z-index: 1;
    border-radius: 8px;
    .main-section {
      text-align: center;
    }
  }
  .non-active-banner-img {
    width: 220px;
    margin-top: 30px;
  }
  .non-ra-banner{
    width: 350px;
    margin-top: 50px;
  }
  .details-box {
    width: fit-content;
    text-align: left;
    // border: 1px solid #f4fbff;
    border: 1px solid #e8f2f7;
    padding: 20px;
    background-color: #e8f2f7;
    border-radius: 9px;
    box-shadow: 1px 2px 10px -4px #a5a5a5;
    .head {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      font-weight: 700;
      font-size: 1.1rem;
    }
    .lock-img {
      border: 1px solid $secondary-theme-color;
      border-radius: 50%;
      background: $secondary-theme-color;
      padding: 7px;
      margin-right: 10px;
    }
    .el-icon-check {
      color: $secondary-theme-color;
      font-weight: bolder;
      margin-right: 10px;
      font-size: 1rem;
    }
    .list {
      font-size: 0.7rem;
      font-weight: 500;
    }
  }
  .publish-btn {
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto 10px;
    font-weight: 700;
    cursor: pointer;

    img {
      width: 25px;
      position: relative;
      bottom: 2px;
      left: 5px;
    }
  }
  .publish-btn:hover {
    background-color: #e72726;
  }
  .bottom-txt {
    font-size: 0.7rem;
    font-weight: 600;
  }


  @media screen and (max-width: 1283px) {
    .component-inner-section{
      width: 100%;
      left: 0;
    }
  }
}
</style>
